module.exports = __webpack_public_path__ + "img/lc.e8ab05c4.svg";